export default "__VITE_ASSET__8861e8b7__"